<script lang="ts">
  import { SplideSlide } from '@splidejs/svelte-splide';
  import { Carousel } from '..';
  import { Modal } from '.';
  import { getImageIndex } from '../../helpers/sections-helper';
  import { GALLERY_CAROUSEL_OPTIONS } from '../../components/constants/carousel';
  import type { GlobalProperties } from 'customer-components/lib/types';

  export let images = [];
  export let heading = '';
  export let color = '';
  export let headingFont: GlobalProperties['headingFont'];
  export let rounded = '';
  export let objectFit = 'cover';

  let imgIndex;
  let showModal;

  const openImage = index => {
    imgIndex = getImageIndex(images.length, index - 1);
    showModal = true;
  };
</script>

<div class="container" style="color: {color}">
  <h2 style="font-family: {headingFont?.title || 'DM Sans'}">
    {@html heading}
  </h2>

  <div class="grid-container">
    {#each images as image, index}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div
        class="flex-row-item"
        role="button"
        tabindex="0"
        aria-label="image gallery"
        on:click={() => openImage(index)}
      >
        <img
          style="object-fit:{objectFit};"
          src={image}
          alt="grid-img"
          width="369"
          height="230"
        />
      </div>
    {/each}
  </div>
</div>

<Modal bind:show={showModal}>
  <Carousel options={GALLERY_CAROUSEL_OPTIONS(imgIndex)}>
    {#each images as image, index (index)}
      <SplideSlide>
        <img
          style="border-radius: {rounded}px; object-fit:{objectFit};"
          src={image}
          alt=""
        />
      </SplideSlide>
    {/each}
  </Carousel>
</Modal>

<style>
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding-right: 10px;
    padding-left: 10px;
  }
  .grid-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-column-gap: 6px;
    grid-row-gap: 6px;
  }

  .flex-row-item {
    height: 250px;
    padding: 10px;
  }
  h2 {
    padding-left: 10px;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
  }
  :global(.gallery-prev) {
    left: 20vw !important;
  }
  :global(.gallery-next) {
    right: 20vw !important;
  }
  :global(.gallery-pagination) {
    bottom: -30px !important;
  }
  @media screen and (max-width: 280px) {
    .grid-container {
      grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    }
  }
  @media screen and (max-width: 640px) {
    h2 {
      font-size: 35px;
    }
  }
</style>
